var React = require('react');

function Feature3 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32.4648","cy":"41.7609","r":"20.7042","fill":"black","key":0}),React.createElement("circle",{"cx":"35","cy":"35","r":"27.5","stroke":"black","strokeWidth":"5","key":1}),React.createElement("circle",{"cx":"40.9155","cy":"35.8444","r":"5.49296","fill":"white","key":2})]);
}

Feature3.defaultProps = {"width":"70","height":"70","viewBox":"0 0 70 70","fill":"none"};

module.exports = Feature3;

Feature3.default = Feature3;
